// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhl_ji","CommentListPlaceholder--Legacy":"ih_b bhl_ra bhl_wo"};